import {find, map} from 'lodash'
import Storage from './Storage'
import Auth from './Auth'
import moment from 'moment'

export default {
  areByWm () {
    return Storage.OldbyWmFilter ? 'by_wm=web1&' : ''
  },
  getExportedOffers (dOffers) {
    const selectedOffers = this.findSelectedOffers(dOffers)
    let offers = []
    if (selectedOffers.length === 0) {
      return 'All'
    } else {
      selectedOffers.map((d) => {
        offers.push(d.name)
      })
      return offers.join(', ')
    }
  },
  getWebsList () {
    let ids = []
    map(Storage.webSelectedFilter, (d) => {
      ids.push(d.login)
    })
    return ids.join(',')
  },
  getWebmasterId () {
    let ids = []
    map(Storage.selectedWebmaster, (d) => {
      ids.push(d.id)
    })
    return ids.join(',')
  },
  getWebsListNew () {
    let ids = []
    map(Storage.webNewSelectedFilter, (d) => {
      ids.push(d.name)
    })
    return ids.join(',')
  },
  getWebsTags () {
    let ids = []
    map(Storage.webAddTagFilter, (d) => {
      ids.push(d.name)
    })
    return ids.join(',')
  },
  getOffersList () {
    let ids = []
    map(Storage.selectedOffer, (d) => {
      ids.push(d.id)
    })
    return ids.join(',')
  },
  getCountryList (isAllowedFilteringByAllCountries = true) {
    let ids = []

    if (Storage.selectedCountry.length) {
      const allCountriesObj = Storage.selectedCountry.find(country => country.id === -1)

      if (allCountriesObj) {
        // запрещаем подрубать фильтр, если выключен флаг фильтрации по всем странам
        if (!isAllowedFilteringByAllCountries) return '-1'

        Storage.countries.map(country => {
          ids.push(country.id)
        })
      } else {
        map(Storage.selectedCountry, d => {
          ids.push(d.id)
        })
      }

      return ids.join(',')
    } else {
      return Storage.selectedCountry.id
    }
    // if (Storage.selectedCountry || Storage.selectedCountry.length) {
    //   map(Storage.selectedCountry, (d) => {
    //     ids.push(d.id)
    //   })
    //   return ids.join(',')
    // }
  },
  getCouriersList () {
    let ids = []
    map(Storage.selectedCouriers, (d) => {
      ids.push(d.id)
    })
    return ids.join(',')
  },
  getxstart (all, start) {
    if (start && all) {
      return parseFloat(parseFloat(all) / parseFloat(start)).toFixed(2)
    } else {
      return 1
    }
  },
  getSumCount (sum, count) {
    if (sum && count) {
      return (parseFloat(sum) / parseFloat(count)).toFixed(1)
    } else {
      return 0
    }
  },
  getOperatorsList () {
    let ids = []
    map(Storage.selectedOperator, (d) => {
      ids.push(d.id)
    })
    return ids.join(',')
  },
  getDataRangeSearch (month) {
    let month1 = moment(Storage.selectedDateFrom).format('MM').replace('0', '')
    let month2 = moment(Storage.selectedDateTo).format('MM').replace('0', '')
    let selectedDateFrom = moment(Storage.selectedDateFrom).format('YYYY-MM-DD')
    let selectedDateTo = moment(Storage.selectedDateTo).format('YYYY-MM-DD')
    let lastDay = moment(Storage.selectedDateFrom).endOf('month').format('YYYY-MM-DD')
    let firstDay = moment(Storage.selectedDateTo).startOf('month').format('YYYY-MM-DD')
    if (month1 !== month2 && month === month1) {
      return `&date_from=${selectedDateFrom}&date_to=${lastDay}`
    }
    if (month1 !== month2 && month === month2) {
      return `&date_from=${firstDay}&date_to=${selectedDateTo}`
    }
    if (month1 === month2) {
      return `&date_from=${selectedDateFrom}&date_to=${selectedDateTo}`
    }
  },
  getDataRangeSearch2 (month) {
    let month1 = moment(Storage.selectedDateFrom).format('MM').replace('0', '')
    let month2 = moment(Storage.selectedDateTo).format('MM').replace('0', '')
    let selectedDateFrom = moment(Storage.selectedDateFrom).format('YYYY-MM-DD')
    let selectedDateTo = moment(Storage.selectedDateTo).format('YYYY-MM-DD')
    let lastDay = moment(Storage.selectedDateFrom).endOf('month').format('YYYY-MM-DD')
    let firstDay = moment(Storage.selectedDateTo).startOf('month').format('YYYY-MM-DD')
    if (month === month1) {
      return `&date_from=${selectedDateFrom}&date_to=${lastDay}`
    }
    if (month === month2 && month === month2) {
      return `&date_from=${firstDay}&date_to=${selectedDateTo}`
    }
  },
  getDateRangeFrom () {
    return `&date_from=${moment(Storage.selectedMonthFrom).format('YYYY-MM')}`
  },
  getDateRange () {
    return `&date_from=${moment(Storage.selectedDateFrom).format('YYYY-MM-DD')}&date_to=${moment(Storage.selectedDateTo).format('YYYY-MM-DD')}`
  },
  getDateRangeAnalyticsSecond () {
    return `&second_date_from=${moment(Storage.selectedDateFromSecond).format('YYYY-MM-DD')}&second_date_to=${moment(Storage.selectedDateToSecond).format('YYYY-MM-DD')}`
  },
  getDateRangeAnalytics () {
    return `&first_date_from=${moment(Storage.selectedDateFrom).format('YYYY-MM-DD')}&first_date_to=${moment(Storage.selectedDateTo).format('YYYY-MM-DD')}`
  },
  getDateCreatedRange () {
    if (!Storage.selectedDateCreatedFrom && !Storage.selectedDateCreatedTo) {
      return `&date_from=&date_to=`
    } else {
      return `&date_from=${moment(Storage.selectedDateCreatedFrom).format('YYYY-MM-DD')}&date_to=${moment(Storage.selectedDateCreatedTo).format('YYYY-MM-DD')}`
    }
  },
  getDateReceiptRange () {
    if (!Storage.selectedDateReceiptFrom && !Storage.selectedDateReceiptTo) {
      return `&receipt_date_from=&receipt_date_to=`
    } else {
      return `&receipt_date_from=${moment(Storage.selectedDateReceiptFrom).format('YYYY-MM-DD')}&receipt_date_to=${moment(Storage.selectedDateReceiptTo).format('YYYY-MM-DD')}`
    }
  },
  getMonthRange () {
    return `&date_from=${moment(Storage.selectedMonthFrom).format('YYYY-MM')}&date_to=${moment(Storage.selectedMonthTo).format('YYYY-MM')}`
  },
  percents (total, count) {
    if (total === 0 || count === 0) {
      return (`0%`)
    }
    return (`${parseFloat(parseFloat(count) / parseFloat(total) * 100).toFixed(1)}%`).replace('.', ',')
  },
  percentsC (total, count) {
    if (total === 0 || count === 0) {
      return 0
    }
    return parseInt(parseFloat(count) / parseFloat(total) * 100)
  },
  percentsF (total, count) {
    if (total === 0 || count === 0) {
      return 0
    }
    return parseFloat((parseFloat(count) / parseFloat(total) * 100).toFixed(1))
  },
  averageDbt (sum, countryId) {
    return parseFloat(parseFloat(sum) / this.findCountry(countryId).rate).toFixed(2)
  },
  leadIncrease (price, approved, total, date, daysTotal) {
    let approvedPercent = (parseInt(approved) / parseInt(total)).toFixed(2)
    let expensesKC = Number(price) * parseInt(approved)
    if (!price) {
      return `${(((0 * parseInt(approved)) / ((parseInt(total) / date) * daysTotal)) * parseInt(approved) / parseInt(total))}`
    } else {
      return `${(expensesKC / ((parseInt(total) / date) * daysTotal * approvedPercent)).toFixed(2)}`
    }
  },
  averageBill (averageBill, count, clean) {
    if (!count) {
      if (!clean) {
        return (`$ ${parseFloat(parseFloat(averageBill) / parseFloat(Storage.selectedCountry.rate)).toFixed(2)}`).replace('.', ',')
      } else {
        return parseFloat((parseFloat(averageBill) / parseFloat(Storage.selectedCountry.rate)).toFixed(2))
      }
    } else {
      return (`$ ${parseFloat(parseFloat(averageBill) / parseFloat(Storage.selectedCountry.rate) / parseFloat(count)).toFixed(2)}`).replace('.', ',')
    }
  },
  averageBillDay (averageBill, rate, clean) {
    if (!clean) {
      return (`$ ${parseFloat(parseFloat(averageBill) / parseFloat(rate)).toFixed(2)}`).replace('.', ',')
    } else {
      return parseFloat(parseFloat(averageBill) / parseFloat(rate)).toFixed(2)
    }
  },
  averageBillDayCount (averageBillSum, count) {
    if (averageBillSum === 0) {
      return (`$ 0,00`)
    }
    return (`$ ${parseFloat(parseFloat(averageBillSum).toFixed(0) / count).toFixed(2)}`).replace('.', ',')
  },
  localAverageBill (averageBill, count) {
    if (!count) {
      return (`${parseFloat(averageBill).toFixed(0)} ${Storage.selectedCountry.currency_symbol}`).replace('.', ',')
    } else {
      return (`${parseFloat(parseFloat(averageBill).toFixed(0) / count).toFixed(0)} ${Storage.selectedCountry.currency_symbol}`).replace('.', ',')
    }
  },
  renderGist (total, percents, color) {
    return `<td class="double" style="position: relative">
                <div style="position: absolute; width: ${percents}; height: 50px; background-color: ${color};"></div>
                <span>${total}</span> <span>${percents}</span>
            </td>`
  },
  average (sum, count) {
    if (sum === 0 || count === 0) {
      return 0
    }
    const average = parseInt(parseFloat(sum) / parseFloat(count), 10)
    return isNaN(average) ? 0 : average
  },
  averageFloat (sum, count) {
    if (sum === 0 || count === 0) {
      return 0
    }
    const average = parseFloat(parseFloat(sum) / parseFloat(count)).toFixed(2)
    return isNaN(average) ? 0 : average
  },
  renderSingleGist (total, count) {
    if (total === 0 || count === 0) {
      return 0
    }
    return parseFloat(count) / parseFloat(total) * 100
  },
  renderSingleGistMin (total, count) {
    if (total === 0 || count >= 0) {
      return 0
    }
    return parseFloat(count) / parseFloat(total) * 100
  },
  renderGistPart (total, count, secondPart) {
    if (total === 0 || count === 0) {
      return 0
    }
    const percents = parseFloat(count) / parseFloat(total) * 100
    let first = 0
    let second = 0
    if (percents > 50) {
      first = 100
      second = (percents - 50) / 50 * 100
    } else {
      first = percents * 2
    }
    if (secondPart) {
      return second
    } else {
      return first
    }
  },
  getRawNumber (value) {
    return parseFloat((`${value}`).replace(',', '.').replace('$ ', ''))
  },
  getOfferTitle (offers, id) {
    // TODO: фикс на сервера (убрать тестовые офферы)
    let offer = find(offers, {id: parseInt(id, 10)})
    if (!offer) {
      return false
    } else {
      return offer.title
    }
  },
  getGoodNameById (goods, id) {
    let good = find(goods, {id: parseInt(id)})
    if (!good) {
      return 404
    } else {
      return good.name
    }
  },
  getGoodName (goods, id) {
    let good = find(goods, {alias: `${id}`})
    if (!good) {
      return false
    } else {
      return good.name
    }
  },
  getOperatorLogin (operators, id) {
    if (parseInt(id) === 0) {
      return 'Administrator'
    }
    let operator = find(operators, {id: `${id}`})
    if (!operator) {
      return 404
    } else {
      return operator.login
    }
  },
  getOperatorLoginEmpty (operators, id) {
    let operator = find(operators, {id: `${id}`})
    if (!operator) {
      return ''
    } else {
      return operator.login
    }
  },
  getWebLogin (web, id) {
    let webName = find(web, {personal_id: parseInt(id)})
    if (!webName) {
      return 404
    } else {
      return webName.login
    }
  },
  getWebLoginCountry (web, id, country) {
    let webNameCountry = web.filter(w => w.country_id === country)
    let nameweb = find(webNameCountry, {personal_id: parseInt(id)})
    if (nameweb) {
      return nameweb.login
    } else {
      return 404
    }
  },
  getCancelName (cancels, id) {
    let cancel = find(cancels, {id: parseInt(id)})
    if (!cancel) {
      return 4004
    } else {
      return cancel.text
    }
  },
  getCourierTitle (couriers, id) {
    let courier = find(couriers, {id: parseInt(id)})
    if (!courier) {
      return 404
    } else {
      return courier.title
    }
  },
  getSmsText (templates, id) {
    let sms = find(templates, {id: parseInt(id)})
    if (!sms) {
      return 'СМС не найдено'
    } else {
      return sms.text
    }
  },
  getCourierTitleWithUndefinedCourier (couriers, id) {
    let courier = find(couriers, {id: parseInt(id)})
    if (!courier) {
      return 'Undefined'
    } else {
      return courier.title
    }
  },
  findCountry (id) {
    let country = find(Storage.countries, {id: parseInt(id, 10)})
    if (!country) {
      return Storage.countries[Object.keys(Storage.countries)[0]]
    } else {
      return country
    }
  },
  findCountryName (id) {
    let country = find(Storage.countries, {id: parseInt(id, 10)})
    if (!country) {
      return Storage.countries[Object.keys(Storage.countries)[0]]
    } else {
      return country.name
    }
  },
  getCountryTitle (country, id) {
    let countryTitle = find(country, {id: parseInt(id)})
    if (!countryTitle) {
      return 404
    } else {
      return countryTitle.name
    }
  },
  findSelectedOffers (idsLine) {
    if (idsLine) {
      const ids = idsLine.split(',')
      let offers = []
      ids.map((id) => {
        const offer = find(Storage.offers, {id: parseInt(id, 10)})
        if (offer) {
          offers.push(offer)
        }
      })
      return offers
    } else {
      return []
    }
  },
  findSelectedOperators (idsLine) {
    if (idsLine) {
      const ids = idsLine.split(',')
      let operators = []
      ids.map((id) => {
        let operator = find(Storage.operators, {id: `${id}`})
        if (operator) {
          operators.push(operator)
        }
      })
      return operators
    } else {
      return []
    }
  },
  findSelectedCouriers (idsLine) {
    if (idsLine) {
      const ids = idsLine.split(',')
      let couriers = []
      ids.map((id) => {
        let courier = find(Storage.couriers, {id: `${id}`})
        if (courier) {
          couriers.push(courier)
        }
      })
      return couriers
    } else {
      return []
    }
  },
  findSelectedWebs (idsLine) {
    if (idsLine) {
      const ids = idsLine.split(',')
      let webFilter = []
      ids.map((id) => {
        let webFilter = find(Storage.webFilter, {id: `${id}`})
        if (webFilter) {
          webFilter.push(webFilter)
        }
      })
      return webFilter
    } else {
      return []
    }
  },
  s2ab (s) {
    if (typeof ArrayBuffer !== 'undefined') {
      let buf = new ArrayBuffer(s.length)
      let view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
      return buf
    } else {
      let buf = new Array(s.length)
      for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
      return buf
    }
  },
  checkLang () {
    if (Auth.user.profile && Auth.user.profile.lang !== Storage.language) {
      localStorage.setItem('lang', Auth.user.profile.lang)
      if (Storage.enterRouter.fullPath) {
        window.location = Storage.enterRouter.fullPath
      } else {
        window.location.reload()
      }
    }
  },
  isInt (n) {
    return Number(n) === n && n % 1 === 0
  },
  isFloat (n) {
    return Number(n) === n && n % 1 !== 0
  },
  getDateOfISOWeek (w, y) {
    let simple = new Date(y, 0, 1 + (w - 1) * 7)
    let dow = simple.getDay()
    let ISOweekStart = simple
    if (dow <= 4) {
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1)
    } else {
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay())
    }
    return ISOweekStart
  },
  hourAndMin (data) {
    let hourse = Math.floor(data / 60 / 60)
    let minutes = Math.floor(data / 60) - (hourse * 60)
    let seconds = Math.floor(data % 60)
    return `${hourse} ч. ${minutes} м. ${seconds} с.`
  },
  newLocalAverageBill (averageBill, count, currency) {
    if (!count) {
      return (`${parseFloat(averageBill).toFixed(0)} ${currency}`).replace('.', ',')
    } else {
      return (`${Math.round(parseFloat(Math.round(Number(averageBill)) / count))} ${currency}`)
      // return (`${parseFloat(parseFloat(averageBill).toFixed(0) / count).toFixed(0)} ${currency}`).replace('.', ',')
    }
  },
  newAverageBillDay (averageBill, count, currency) {
    if (!currency) {
      return (`${(averageBill * count).toFixed(0)}`)
    } else {
      return (`${(averageBill * count).toFixed(0)} ${currency}`)
    }
  },
  percentHungry (value, count) {
    if (!count) {
      return '0 %'
    } else {
      return `${((value / count) * 100).toFixed(2)} %`
    }
  },
  approvedFromValid (approved, total, spam) {
    return `${((approved / (total - spam)) * 100).toFixed(1)}%`
  }
  // returnCountyId (country) {
  //   let countryArr = []
  //   try {
  //     if (country && country.length) {
  //       country.forEach(item => {
  //         countryArr.push(item.id)
  //       })
  //     }
  //   } catch (error) {
  //     console.log(error)
  //   }
  //   return countryArr
  // }
}



// WEBPACK FOOTER //
// ./src/api/Helper.js